import create from "zustand";
import { devtools } from "zustand/middleware";

const useNotificationStore = create(
  devtools((set) => ({
    longList: [],
    setLongList: (longList) => set({ longList }),
    shortList: [],
    setShortList: (shortList) => set({ shortList }),
    hasUnread: false,
    setHasUnread: (hasUnread) => set({ hasUnread }),
  })),
  "iperform-notifications"
);

export default useNotificationStore;
